import { SpecialPermissions } from './specialPermissions';
import { UpdateSpecialPermissions } from './updateSpecialPermissions';

export const specialPermissionsRootReducer = {
  specialPermissions: SpecialPermissions,
  updateSpecialPermissions: UpdateSpecialPermissions,
};
